import React from 'react';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner';

const FileProgress = ({
  progress = 0,
}) => (
  <>
    <FA icon={faSpinner} fixedWidth pulse className="mr-2" />
    {Math.round(progress * 100)}%
  </>
);

export default FileProgress;
